type ColumnArrows = {
  previousGroup: string;
  nextGroup: string;
  color: string;
};

export const columnArrows: ColumnArrows[][] = [
  [
    { previousGroup: "0:0", nextGroup: "1:0", color: "green" },
    { previousGroup: "0:0", nextGroup: "0:1", color: "red" },
  ],
  [
    { previousGroup: "1:0", nextGroup: "2:0", color: "green" },
    { previousGroup: "1:0", nextGroup: "1:1", color: "red" },
    { previousGroup: "0:1", nextGroup: "1:1", color: "green" },
    { previousGroup: "0:1", nextGroup: "0:2", color: "red" },
  ],
  [
    { previousGroup: "2:0", nextGroup: "2:1", color: "red" },
    { previousGroup: "1:1", nextGroup: "2:1", color: "green" },
    { previousGroup: "1:1", nextGroup: "1:2", color: "red" },
    { previousGroup: "0:2", nextGroup: "1:2", color: "green" },
  ],
  [
    { previousGroup: "2:1", nextGroup: "2:2", color: "red" },
    { previousGroup: "1:2", nextGroup: "2:2", color: "green" },
  ],
];
